import { getSizeLimit } from './get-size-limit';

export const getResponsiveWidthOfContainer = (width) => getSizeLimit(width);
